import { globals } from '@/src/globals'

export const pricingExtraTextManager = (pricingBlock: HTMLElement): void => {
  const pricingTables = pricingBlock.querySelectorAll('.js-pricing-table') as unknown as HTMLElement[]

  pricingTables.forEach(singleTable => {
    const pricingTextWrapperList = singleTable.querySelectorAll('.js-pricing-textContent-wrapper') as unknown as HTMLElement[]

    pricingTextWrapperList.forEach(singleWrapper => {
      let singleTrigger = singleWrapper.querySelector('.js-pricing-textContent-trigger')
      if (singleTrigger === null && singleWrapper.classList.contains('js-pricing-textContent-trigger')) {
        singleTrigger = singleWrapper
      }

      if (singleTrigger) {
        singleWrapper.addEventListener('click', () => {
          const extraText = singleWrapper.querySelector('.pricing_2022__extraText') as unknown as HTMLElement

          if (singleWrapper.classList.contains('-opened')) {
            jQuery(extraText).animate({ height: '0px' }, 300)
            setTimeout(() => {
              jQuery(extraText).hide()
              singleWrapper.classList.remove('-opened')
              singleWrapper.classList.add('-animating')
            }, 250)
            setTimeout(() => {
              jQuery(extraText).removeAttr('style')
              singleWrapper.classList.remove('-animating')
            }, 350)
          } else {
            singleWrapper.classList.add('-animating')
            setTimeout(() => {
              const extraTextHeight = extraText.scrollHeight

              jQuery(extraText).height('0px')

              setTimeout(() => {
                singleWrapper.classList.remove('-animating')
                jQuery(extraText).animate({ height: `${extraTextHeight}px` }, 300)
              }, 50)

              singleWrapper.classList.add('-opened')

              setTimeout(() => {
                jQuery(extraText).removeAttr('style')
              }, 400)
            }, 10)
          }
        })
      }
    })
  })
}
